// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 42">
            <g fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="m41.392 39.633-9.472-9.476.314-.378A18.209 18.209 0 0 0 36.403 18.2C36.403 8.164 28.237 0 18.2 0 8.166 0 0 8.163 0 18.2s8.166 18.198 18.2 18.198c4.216 0 8.329-1.48 11.58-4.169l.38-.314 9.474 9.476c.47.47 1.292.47 1.758 0a1.24 1.24 0 0 0 0-1.758M18.2 33.915c-8.664 0-15.714-7.05-15.714-15.715S9.537 2.486 18.2 2.486c8.665 0 15.714 7.05 15.714 15.714 0 8.665-7.05 15.715-15.714 15.715"
                />
            </g>
        </svg>
    );
};

export default React.memo(Search);
